<template>
	<BaseModal class="modal--centered" :closable="true" @dismiss="$emit('dismiss')">
		<div class="lists-for-signed-in-users-modal__wrapper">
			<div class="modal-header-icon">
				<FontAwesomeIcon :icon="faBookmark" />
			</div>

			<div class="modal-content">
				<h2 class="modal-content__header">{{ header }}</h2>
				<span class="modal-content__body">{{ body }}</span>
			</div>

			<div class="modal-footer">
				<BasicButton class="modal-footer__item" color="dark" @click="openAccountModal(AccountModes.SIGN_UP)">
					{{ $t('WEBAPP_SIGN_UP') }}
				</BasicButton>

				<BasicButton class="modal-footer__item" color="primary" @click="openAccountModal(AccountModes.SIGN_IN)">
					{{ $t('WEBAPP_LOGINS_SIGNIN') }}
				</BasicButton>
			</div>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import BasicButton from '@/ui-components/BasicButton.vue';
import BaseModal from '@/components/modals/vfm/BaseModal.vue';

import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { AccountModal } from '@/lazy-load-components';
import { AccountModes } from '@/enums/login';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { faBookmark } from '@fortawesome/free-solid-svg-icons';

defineProps<{ header: string; body: string }>();

function openAccountModal(startScreen: AccountModes.SIGN_IN | AccountModes.SIGN_UP) {
	VFMHelper.close();

	ModalHelper.openModal(AccountModal, { closable: true, startScreen }, { cssClass: 'account-modal' });

	TrackingHelper.trackEvent('user_account', {
		action: startScreen === AccountModes.SIGN_IN ? 'account_sign_in_clicked' : 'account_create_clicked',
		property: 'WatchlistSignupModal',
	});
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.lists-for-signed-in-users-modal {
	.modal-wrapper {
		@media (min-width: $screen-xs) {
			width: 578px;
			height: 480px;
			border-radius: 16px;
		}
	}

	&__wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		height: 100%;
		padding: 0 64px 48px;

		@media (max-width: $screen-xs) {
			justify-content: normal;
			padding: 0 16px 24px;
		}

		.modal-header-icon {
			display: flex;
			justify-content: center;
			align-items: center;
			justify-self: end;
			margin: 0;
			min-height: 64px;
			height: 64px;
			min-width: 64px;
			width: 64px;
			padding-left: 0;
			padding-right: 0;
			font-size: 32px;
			background-color: $btn-mark-as-seen-color-darkblue;
			color: white;
			border-radius: 50%;
		}

		.modal-content {
			height: 100%;
			&__header {
				margin-bottom: 24px;
			}
		}

		.modal-footer {
			width: 100%;
			margin-top: 32px;

			@media (max-width: $screen-xs) {
				display: flex;
				flex-direction: column;
			}

			&__item {
				margin: 0 8px;

				@media (max-width: $screen-xs) {
					margin: 8px 0;
				}

				&.basic-button {
					padding: 12px 60px;

					@media (max-width: $screen-xs) {
						padding: 10px 50px;
					}
				}
			}
		}
	}
}
</style>
